module.exports = __webpack_public_path__ + "static/media/logo_option1.919a5cde.png";